import React from 'react'
import { TileLayer, LayersControl } from "react-leaflet";

const Layers = () => (
  <LayersControl position="topright">
    <LayersControl.BaseLayer name="OpenStreetMap - Standard">
      <TileLayer
        attribution='<p aria-hidden="true" tabindex="-1">&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors</p>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer checked name="LINZ Aerial Basemap">
      <TileLayer
        attribution='<p aria-hidden="true" tabindex="-1">Map data © LINZ CC BY 4.0 © Imagery Basemap contributors | All other data sourced from <a tabindex="-1" href="https://data.linz.govt.nz/">LINZ Data Service</a></p>'
        url="https://basemaps.linz.govt.nz/v1/tiles/aerial/3857/{z}/{x}/{y}.jpeg?api=d01egend5fc4dnm1e1tzzq08nfb"
      />
    </LayersControl.BaseLayer>
    <LayersControl.Overlay name="LINZ TOPO 50">
      <TileLayer
        attribution='<p aria-hidden="true" tabindex="-1">Map data © LINZ CC BY 4.0 © Imagery Basemap contributors | All other data sourced from <a tabindex="-1" href="https://data.linz.govt.nz/">LINZ Data Service</a></p>'
        url="https://tiles-a.data-cdn.linz.govt.nz/services;key=3e78150f9b2645228602e113fbc2a586/tiles/v4/layer=2343/EPSG:3857/{z}/{x}/{y}.png"
      />
    </LayersControl.Overlay>
  </LayersControl>
)
export default Layers

export const DynamicLayerControl = ({ defaultOverlay }) => (
  <LayersControl position="topright">
            <LayersControl.BaseLayer name="OpenStreetMap - Standard">
              <TileLayer
                attribution='<p aria-hidden="true" tabindex="-1">&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors</p>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer checked name="LINZ Aerial Basemap">
              <TileLayer
                attribution='<p aria-hidden="true" tabindex="-1">Map data © LINZ CC BY 4.0 © Imagery Basemap contributors | All other data sourced from <a tabindex="-1" href="https://data.linz.govt.nz/">LINZ Data Service</a></p>'
                url="https://basemaps.linz.govt.nz/v1/tiles/aerial/3857/{z}/{x}/{y}.jpeg?api=d01egend5fc4dnm1e1tzzq08nfb"
              />
            </LayersControl.BaseLayer>
            <LayersControl.Overlay checked={defaultOverlay === 50} name="LINZ TOPO 50">
              <TileLayer
                attribution='<p aria-hidden="true" tabindex="-1">Map data © LINZ CC BY 4.0 © Imagery Basemap contributors | All other data sourced from <a tabindex="-1" href="https://data.linz.govt.nz/">LINZ Data Service</a></p>'
                url="https://tiles-a.data-cdn.linz.govt.nz/services;key=3e78150f9b2645228602e113fbc2a586/tiles/v4/layer=2343/EPSG:3857/{z}/{x}/{y}.png"
              />
            </LayersControl.Overlay>

            <LayersControl.Overlay checked={defaultOverlay === 250} name="LINZ TOPO 250">
              <TileLayer
                attribution='<p aria-hidden="true" tabindex="-1">Map data © LINZ CC BY 4.0 © Imagery Basemap contributors | All other data sourced from <a tabindex="-1" href="https://data.linz.govt.nz/">LINZ Data Service</a></p>'
                url="https://tiles-a.data-cdn.linz.govt.nz/services;key=3e78150f9b2645228602e113fbc2a586/tiles/v4/layer=50798/EPSG:3857/{z}/{x}/{y}.png"
              />
            </LayersControl.Overlay>
        </LayersControl>
)